import { isRouteErrorResponse, useRouteError } from "react-router-dom";

// Màn hình lỗi chung cho router, thay cho trang stack trace mặc định của
// react-router. Lỗi hay gặp nhất ngoài thực tế là NotFoundError từ
// removeChild/insertBefore khi trình duyệt tự dịch trang và sửa DOM sau lưng
// React; tải lại trang là đủ để người dùng dùng tiếp.
export default function RouteErrorPage() {
  const error = useRouteError();
  console.error(error);

  const isNotFound = isRouteErrorResponse(error) && error.status === 404;
  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? `${error.name}: ${error.message}`
      : String(error);

  return (
    <div
      translate="no"
      className="min-h-screen flex flex-col items-center justify-center gap-4 px-6 text-center bg-[#0A0D17] text-white"
    >
      <h1 className="text-xl font-bold">
        {isNotFound ? "Không tìm thấy trang" : "Đã có lỗi xảy ra"}
      </h1>
      <p className="text-sm text-gray-300 max-w-sm">
        {isNotFound
          ? "Trang bạn tìm không tồn tại hoặc đã bị xoá."
          : "Vui lòng tải lại trang. Nếu trình duyệt đang bật dịch trang tự động, hãy tắt dịch cho biadi.vn rồi thử lại."}
      </p>
      <div className="flex gap-3">
        {!isNotFound && (
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="px-4 py-2 rounded-lg bg-white text-black font-semibold"
          >
            Tải lại trang
          </button>
        )}
        <button
          type="button"
          onClick={() => window.location.assign("/")}
          className="px-4 py-2 rounded-lg border border-white/40 font-semibold"
        >
          Về trang chủ
        </button>
      </div>
      <p className="text-[11px] text-gray-500 break-all max-w-sm">{detail}</p>
    </div>
  );
}
